import React, { useState, useEffect, useMemo } from "react";
import Cron from "react-js-cron";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Switch from "../../../../../../Common/Switch";

import { convertTimezone, setPrevState } from "../../../../../../../util/common";
import { useCronReducer } from "../../../../../../../util/cron";

function SchedulePanel(props) {
  const { state, setState, cronScheduleRef } = props;
  const { timeZone, scheduleEnabled, nextRunTime } = useMemo(() => state, [state]);

  const [closeSelect, setCloseSelect] = useState(false);

  const [values, dispatchValues] = useCronReducer(cronScheduleRef.current);

  const nextRunDisplay = useMemo(
    () => (nextRunTime ? `Next Job run time: ${convertTimezone(nextRunTime)}` : ``),
    [nextRunTime]
  );

  // Code for solving floating select Issue
  useEffect(() => {
    if (document.getElementById("main_box"))
      document.getElementById("main_box").onscroll = () => {
        setCloseSelect(true);
        setCloseSelect(false);
      };
  }, []);

  useEffect(() => {
    cronScheduleRef.current = values.cronValue;
  }, [cronScheduleRef, values.cronValue]);

  return (
    <Grid container direction="row">
      <Grid justifyContent="flex-start" display="flex" size={6}>
        <FormControl className="switch" component="fieldset">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value={scheduleEnabled}
              control={<Switch />}
              label="Enable Scheduler"
              labelPlacement="start"
              sx={{ margin: "0", mb: 2, marginRight: "20px" }}
              onChange={() => {
                setPrevState(setState, { scheduleEnabled: !scheduleEnabled });
              }}
              checked={scheduleEnabled}
            />
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid justifyContent="flex-end" display="flex" size={6}>
        {timeZone ? `Timezone: ${timeZone}` : ""}
      </Grid>
      <Grid size={12}>
        <Cron
          value={values.cronValue}
          setValue={(newValue) => {
            dispatchValues({
              type: "set_values",
              value: newValue,
            });
          }}
          readOnly={closeSelect}
          defaultPeriod="year"
        />
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "0px !important" }} size={12}>
        <div>
          <InfoOutlinedIcon style={{ marginRight: 5, verticalAlign: "bottom" }} />
          <span style={{ fontSize: 12 }}>
            Double click on a dropdown option to automatically select/unselect a periodicity
          </span>
        </div>
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "15px !important" }} size={12}>
        {scheduleEnabled ? `Scheduled Job: ${values.cronValue}` : ""}
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "5px !important" }} size={12}>
        {scheduleEnabled ? nextRunDisplay : "Disabled or Not scheduled"}
      </Grid>
    </Grid>
  );
}

SchedulePanel.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  cronScheduleRef: PropTypes.object.isRequired,
};

export default React.memo(SchedulePanel);
